const STORAGE_KEY_PREFIX = "tapcart-storefront-bridge";
/**
 * Wishlist localStorage is namespaced by appId + customerId so:
 *  - Multiple Tapcart apps on the same merchant storefront don't collide.
 *  - Guest and logged-in views don't mix (the customer-id segment is
 *    "guest" for anonymous shoppers).
 *
 * TODO: guest → logged-in merge. When a guest later authenticates, their
 * "guest"-scoped wishlist should be merged into the customer-scoped record.
 * Out of scope for v0 (localStorage only); folded in when the App Proxy
 * backend takes over authenticated persistence.
 */
const getStorageKey = (appId, customerId) => `${STORAGE_KEY_PREFIX}:${appId}:${customerId !== null && customerId !== void 0 ? customerId : "guest"}:wishlists`;
const safeJsonParse = (raw, fallback) => {
    if (!raw)
        return fallback;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return fallback;
    }
};
export const loadWishlists = (appId, customerId) => {
    if (typeof window === "undefined")
        return [];
    try {
        const raw = window.localStorage.getItem(getStorageKey(appId, customerId));
        const parsed = safeJsonParse(raw, []);
        // Defensive cast: localStorage is user-mutable (devtools, browser
        // extensions, schema drift between versions). A non-array survives
        // safeJsonParse and crashes downstream `.map()` / `.filter()` in
        // wishlist.ts. Treat anything non-array as empty.
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (_a) {
        // Storage access can throw in privacy-mode / disabled-storage browsers.
        // Behave as if empty rather than crashing the bridge.
        return [];
    }
};
export const saveWishlists = (appId, customerId, wishlists) => {
    if (typeof window === "undefined")
        return;
    try {
        window.localStorage.setItem(getStorageKey(appId, customerId), JSON.stringify(wishlists));
    }
    catch (err) {
        // Quota exceeded, storage disabled, or privacy mode. In-memory variables
        // remain authoritative for the current page; only persistence is lost.
        console.warn("[storefront-bridge] failed to persist wishlists", err);
    }
};
